export default __webpack_public_path__ + "static/media/assignment.94771977.png";